import httpClient from "../httpClient"

import { formatAndEncode } from "../request"
import { amazonKeyFormat } from "../formats"
/**
 *
 * @param {number|string} id // ID of Amazon Key
 */
export function getAmazonKey(id) {
    return httpClient.get(`/access/amznkey/${id}`).then((response) => {
        return response
    })
}

/**
 *
 * @param {number|string} id // ID of Amazon Key
 * @param {object} data
 * - @property {name} string // Name displayed on the Amazon App
 * - @property {address} string
 * - @property {country_id} number // ID of country address
 * - @property {postal_code} string
 * - @property {city} string
 * - @property {state} string // Region or State
 * - @property {image_removal} number // Delete image or not
 * - @property {image} file // Only .PNG or .JPEG
 *
 * @returns {object}
 */
export function activateOrUpdateAmazonKey(id, data) {
    const params = formatAndEncode(amazonKeyFormat, data)

    return httpClient
        .post(`/access/${id}/amznkey/activate`, params)
        .then((response) => {
            return response
        })
}

/**
 *
 * @param {number, string} id // ID of Amazon Key
 */
export function deactivateAmazonKey(id) {
    return httpClient
        .post(`/access/${id}/amznkey/deactivate`)
        .then((response) => {
            return response
        })
}

/**
 *
 * @param {number|string} id // ID of Amazon Key
 *
 * @param {object} data // Query of your request
 * - @property {event} enum
 *      - @property {ACTIVATE} string
 *      - @property {DEACTIVATE} string
 *      - @property {UNLOCK} string
 * - @property {date} string // ISO 8601 format: Ym-d
 * - @property {state} enum
 *      - @property {OK} string
 *      - @property {ERROR} string
 *
 * @returns {object}
 *
 */
export function getEventsAmazonKey(id, data) {
    const params = formatAndEncode(amazonKeyFormat, data)

    return httpClient
        .get(`/access/${id}/amznkey/events`, { params })
        .then((response) => {
            return response
        })
}

export function addAmazonKeyImage(id, data) {
    const formData = new FormData()
    formData.append("image", data.image)

    return httpClient.post(`/access/${id}/amznkey/image`, formData)
}

export function deleteAmazonKeyImage(id) {
    return httpClient.delete(`/access/${id}/amznkey/image`)
}
